// extracted by mini-css-extract-plugin
export default {"empty-state":"_2J-o2","emptyState":"_2J-o2"};